var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AdjustmentTypeList, checkDefaultTrackingTypeAPI, completedStockTransferRequisitionAPI, createWorkPurchaseOrderUrl, DeliveryLocationUrl, getAvailableQtyByWarehouseAPI, getAvailableQuantityAPI, getByStockTransferIdAPI, getPriorityListAPI, getProductPriceAPI, getStatusProgessAPI, LabourListWPOUrl, LocationByWarehouseList, ProductList, SerialNumberList, StatusList, stockTransferRequisitionWithDetailsAPI, stockTransferTypeListAPI, SupplierListWPOUrl, WarehouseList, workPurchaseOrderByJobcardNoUrl, workPurchaseOrderUrl, WPOOrganizationModulesItemSettingUrl } from "../../api/url";
import { createAPI, getByIdAPI, getListAPI } from "../../redux/crudSlice";
import { store } from "../../store/store";
import { WorkPurchaseOrderKeys } from "./entity";
var dispatch = store.dispatch;
export var WorkPurchaseOrderPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? workPurchaseOrderUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var WorkPurchaseOrderByJobcardNoAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.WPOByJobcard : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? workPurchaseOrderByJobcardNoUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var WPOOrganizationModulesItemSettingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? WPOOrganizationModulesItemSettingUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var workPurchaseOrderCreate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.CreateWorkPurchaseOrder : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? createWorkPurchaseOrderUrl : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var getStatusProgress = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.Status : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getStatusProgessAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var getAvailableQtyByWarehouse = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getAvailableQty" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getAvailableQtyByWarehouseAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var getByStockTransfer = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? WorkPurchaseOrderKeys.Get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getByStockTransferIdAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var statusListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? StatusList : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var warehouseListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "warehouseList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? WarehouseList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var productListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "productList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ProductList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
        }
    });
}); };
export var labourListWPOGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload11, _a, key, _b, url, request, res;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "labourListWPO" : _a, _b = params.url, url = _b === void 0 ? LabourListWPOUrl : _b;
                request = {
                    SupplierId: "2ed1d803-6d1d-429b-a52b-487227df1b62"
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _c.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.value];
        }
    });
}); };
export var supplierListWPOGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "supplierListWPO" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? SupplierListWPOUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value];
        }
    });
}); };
export var deliveryLocationGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "deliveryLocation" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? DeliveryLocationUrl : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var adjustmentTypeListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "adjustmentTypeList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? AdjustmentTypeList : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
export var serialNumberListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload15, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "serialNumberList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? SerialNumberList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value];
        }
    });
}); };
export var priorityListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "priorityList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getPriorityListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.value];
        }
    });
}); };
export var stockTransferTypeListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload17, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "stockTransferTypeList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? stockTransferTypeListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.value];
        }
    });
}); };
export var locationByWarehouseListGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload18, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "locationByWarehouseList" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? LocationByWarehouseList : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload18 = res.payload) === null || _res$payload18 === void 0 ? void 0 : _res$payload18.value];
        }
    });
}); };
export var getAvailableQuantityAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload19, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getAvailableQuantity" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getAvailableQuantityAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload19 = res.payload) === null || _res$payload19 === void 0 ? void 0 : _res$payload19.value];
        }
    });
}); };
export var checkDefaultTrackingTypeAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload20, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "checkDefaultTrackingType" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? checkDefaultTrackingTypeAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload20 = res.payload) === null || _res$payload20 === void 0 ? void 0 : _res$payload20.value];
        }
    });
}); };
export var getProductPriceAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload21, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "getProductPrice" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getProductPriceAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload21 = res.payload) === null || _res$payload21 === void 0 ? void 0 : _res$payload21.value];
        }
    });
}); };
export var completedStockTransferRequisitionAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload22, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "completedStockTransferRequisition" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? completedStockTransferRequisitionAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload22 = res.payload) === null || _res$payload22 === void 0 ? void 0 : _res$payload22.value];
        }
    });
}); };
export var stockTransferRequisitionWithDetailsAPIGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload23, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? "stockTransferRequisitionWithDetails" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? stockTransferRequisitionWithDetailsAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload23 = res.payload) === null || _res$payload23 === void 0 ? void 0 : _res$payload23.value];
        }
    });
}); };
